import { useEffect, useState } from 'react';
import { AddComment } from './add-comment';

// components
import { Comment } from './comment';

// helper
import * as helper from './helper';

const Comments = ({ customer, edit }) => {
    const [comments, setComments] = useState([]);

    useEffect(() => {
        let isSubscribed = true;
        const getData = async () => {
            const data = await helper.getUserComments(customer.id);
            setComments(data);
        }

        if (customer?.id && isSubscribed) {
            getData();
        }

        return () => isSubscribed = false
    }, [customer]);

    const handleAdd = (comment) => {
        setComments([comment, ...comments,]);
    }

    const handleDelete = (commentId) => {
        const newComments = comments.filter(x => x.id !== commentId);
        helper.handleDeleteComment(customer.id, commentId)
        setComments(newComments);
    }

    const AddButton = () => {
        if (!edit) {
            return null;
        }

        return (
            <AddComment customer={customer} onAdd={handleAdd} />
        )
    }

    const RenderComments = () => {
        if (!comments?.length) {
            return (
                <article className="message p-6 mt-4">
                    <div className="message-body">This customer does not have any comments.</div>
                </article>
            );
        }

        return (
            <div className="columns is-multiline is-mobile">
                {comments.map((comment, index) => (
                    <div key={`comment-${index}`} className="column is-one-quarter-desktop is-half-mobile">
                        <Comment index={index} comment={comment} onDelete={handleDelete} edit={edit} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="container">
            <div className="is-flex is-justify-content-space-between">
                <p className="title">Comments</p>
                <AddButton />
            </div>


            <RenderComments />
        </div>
    );
};

const CustomerComments = ({ customer, edit = false }) => (
    <Comments edit={edit} customer={customer} />
);

export { CustomerComments };
